export const environment = {     production: false,     apiURL: 'https://rms.soithouse.com',     apiVersion: 'api',     fileServerURL: 'https://rms.soithouse.com/fileserver',     instanceName: 'soithouse'     };
